<template>
  <div class="chart">
    <p class="desc">{{ desc }}</p>
    <canvas ref="barChartCanvas"></canvas>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";

export default {
  props: {
    metric: {
      type: String,
        required: true,
    },
    desc: {
      type: String,
        required: true,
    },
    data: {
      type: Array,
      required: true,
    }
    
  },
  mounted() {
    setTimeout(() => {
      this.prepareDataAndDrawChart();
    }, 100);
  },

  watch: {
    data: {
      immediate: true,
      handler(newData) {
        if (newData.length > 0) {
          this.prepareDataAndDrawChart();
        }
      },
    },
  },

  methods: {
  prepareDataAndDrawChart() {
    const companies = this.data.map(item => item.company);
    const sentimentScores = this.data.map(item => parseFloat(item[this.metric]));
    
    const ctx = this.$refs.barChartCanvas.getContext('2d');

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: companies,
        datasets: [
          {
            label: this.metric,
            data: sentimentScores,
            backgroundColor: sentimentScores.map(score => (score < 0 ? 'rgba(255, 0, 0, 0.2)' : 'rgba(75, 192, 192, 0.2)')),
            borderColor: sentimentScores.map(score => (score < 0 ? 'rgba(255, 0, 0, 1)' : 'rgba(75, 192, 192, 1)')),
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          x: {
            type: 'category',
            title: {
              display: true,
              text: 'Company',
            },
          },
          y: {
            title: {
              display: true,
              text: this.metric,
            },
            beginAtZero: true,
          },
        },
      },
    });
  },
},
};
</script>

<style scoped>
/* Add your custom styles here if needed */
.chart{
    border: solid 1px gray;
    border-radius: 10px;
    /**Border shadow */
    box-shadow: 0 0 40px rgba(0,0,0,0.2);
    padding: -3px;
    margin-bottom: 3px;
}
.desc{
    padding: 10px;
}
</style>
